import formatDistance from 'date-fns/formatDistance';

export const getFormattedDate = (dateGenerated: Date): string => {
  const currentDate = new Date();
  const dateText = formatDistance(dateGenerated, currentDate, { addSuffix: true });
  const dateTextWithCapitalisedFirstLetter = dateText.charAt(0).toUpperCase() + dateText.slice(1);
  return dateTextWithCapitalisedFirstLetter;
};
